import React, { useRef, useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Fieldset } from 'primereact/fieldset';
import { useParams } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';
import { BrCalendar } from './BrCalendar';


import api from '../api/api';

import '../layout/sass/_form.scss';

export const FormBoletimItens = ({ isEditing, isLoading, visible, setVisible, boletimItens, setBoletimItens }) => {

    const { id } = useParams();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [listProdutos, setListProdutos] = useState(null);

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    const schema = Yup.object().shape({
        produtoId: Yup
            .number()
            .required("O produto é obrigatório")
            .positive("O produto deve ser selecionado")
            .integer("O produto deve estar na lista"),
        areaProducao: Yup
            .number()
            .required("A área produção (ha) é obrigatório")
            .max(999999, "A área produção (ha) dete ter no máximo 10 caracteres"),
        producaoEstimada: Yup
            .number()
            .required("A produção estimada é obrigatório")
            .max(9999999999, "A produçao estimada dete ter no máximo 10 caracteres"),
        producaoEmbalada: Yup
            .number()
            .required("A produção embalada é obrigatório")
            .max(9999999999, "A produçao embalada dete ter no máximo 10 caracteres"),
        inicioColheita: Yup
            .date()
            .typeError("Uma data de inicio colheita deve ser inserida")
            .required("A data inicio colheita é obrigatória"),
        fimColheita: Yup
            .date()
            .typeError("Uma data de fim colheita deve ser inserida")
            .required("A data fim colheita é obrigatória"),
    })

    useEffect(() => {

        if (isEditing) {
            api.get(`boletim/${id}`).then((response) => { formik.setValues(response.data); });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps  
    }, []);


    function handleGetProdutos() {

        api.get("produto/listAllProdutoBasic").then((response) => {
            const produtos = response.data.map(item => {
                return {
                    id: item.id,
                    produtoEmbalagem: item.embalagem,
                    produtoNome: item.nome + ' - ' + item.embalagem,
                    nome: item.nome
                }
            });

            setListProdutos(produtos);
        });

    }


    const formik = useFormik({

        initialValues: {
            "produtoId": 0,
            "areaProducao": 0,
            "producaoEstimada": 0,
            "producaoEmbalada": 0,
            "inicioColheita": "",
            "fimColheita": "",
            "itensId": ""
        },

        validationSchema: schema,

        enableReinitialize: false,

        onSubmit: (data) => {
            setIsSubmiting(true)

            let produto = listProdutos.find((produto) => produto.id === data.produtoId);

            data.nome = produto.nome;
            data.produtoEmbalagem = produto.produtoEmbalagem;

            setBoletimItens(boletimItens => [...boletimItens, data]);

            setIsSubmiting(false)
        }
    })




    return (

        <Fieldset legend="Itens" toggleable  >
            <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12">

                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-formgrid p-grid p-fluid p-mx-0">

                            <div className="p-field p-col-12 p-sm-2">
                                <label
                                    htmlFor="produto"
                                    className={classNames({ 'p-error': isFormFieldValid('produto') })}
                                >
                                    Produto
                                </label>
                                {

                                    !isLoading ?
                                        <Dropdown
                                            id="produtoId"
                                            name="produtoId"
                                            options={listProdutos}
                                            filter={true}
                                            emptyMessage={"Nenhuma produto encontrado"}
                                            optionLabel="produtoNome"
                                            optionValue="id"
                                            placeholder="Selecione um produto"
                                            className={classNames({ 'p-invalid': isFormFieldValid('produtoId') })}
                                            value={formik.values.produtoId}
                                            onChange={option => formik.setFieldValue("produtoId", option.value)}
                                            onFocus={handleGetProdutos}
                                            emptyFilterMessage={"Nenhuma produto encontrado"}
                                            disabled={listProdutos === ''}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.produtoId && formik.touched.produtoId &&
                                    <ErrorValidationMessage message={formik.errors.produtoId} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-1">
                                <label
                                    htmlFor="areaProducao"
                                    className={classNames({ 'p-error': isFormFieldValid('areaProducao') })}
                                >
                                    Área Prod. (ha)
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="areaProducao"
                                            name="areaProducao"
                                            type="number"
                                            className={classNames({ 'p-invalid': isFormFieldValid('areaProducao') })}
                                            value={formik.values.areaProducao}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.areaProducao && formik.touched.areaProducao &&
                                    <ErrorValidationMessage message={formik.errors.areaProducao} />
                                }
                            </div>


                            <div className="p-field p-col-12 p-sm-2">
                                <label
                                    htmlFor="producaoEstimada"
                                    className={classNames({ 'p-error': isFormFieldValid('producaoEstimada') })}
                                >
                                    Produção Estimada Kg
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="producaoEstimada"
                                            name="producaoEstimada"
                                            type="number"
                                            className={classNames({ 'p-invalid': isFormFieldValid('producaoEstimada') })}
                                            value={formik.values.producaoEstimada}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.producaoEstimada && formik.touched.producaoEstimada &&
                                    <ErrorValidationMessage message={formik.errors.producaoEstimada} />
                                }
                            </div>


                            <div className="p-field p-col-12 p-sm-2">
                                <label
                                    htmlFor="producaoEmbalada"
                                    className={classNames({ 'p-error': isFormFieldValid('producaoEmbalada') })}
                                >
                                    Produção Embalada
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="producaoEmbalada"
                                            name="producaoEmbalada"
                                            type="number"
                                            className={classNames({ 'p-invalid': isFormFieldValid('producaoEmbalada') })}
                                            value={formik.values.producaoEmbalada}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.producaoEmbalada && formik.touched.producaoEmbalada &&
                                    <ErrorValidationMessage message={formik.errors.producaoEmbalada} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4 p-md-2">
                                <label
                                    htmlFor="inicioColheita"
                                    className={classNames({ 'p-error': isFormFieldValid('inicioColheita') })}
                                >
                                    Inicio Colheita
                                </label>
                                {
                                    !isLoading ?
                                        <BrCalendar
                                            id="inicioColheita"
                                            name="inicioColheita"
                                            disabledDays={[]}
                                            value={new Date(formik.values.inicioColheita).toLocaleDateString()}
                                            onChange={formik.handleChange}
                                            placeholder={isEditing === true ? new Date(formik.values.inicioColheita).toLocaleDateString() : ""}
                                            readonly={true}
                                            className={classNames({ 'p-invalid': isFormFieldValid('inicioColheita') })}
                                            yearRange={`2010:${new Date().getFullYear() + 3}`}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }

                                {formik.errors.inicioColheita && formik.touched.inicioColheita &&
                                    <ErrorValidationMessage message={formik.errors.inicioColheita} />
                                }
                            </div>


                            <div className="p-field p-col-12 p-sm-4 p-md-2">
                                <label
                                    htmlFor="fimColheita"
                                    className={classNames({ 'p-error': isFormFieldValid('fimColheita') })}
                                >
                                    Fim Colheita
                                </label>
                                {
                                    !isLoading ?
                                        <BrCalendar
                                            id="fimColheita"
                                            name="fimColheita"
                                            disabledDays={[]}
                                            value={new Date(formik.values.fimColheita).toLocaleDateString()}
                                            onChange={formik.handleChange}
                                            placeholder={isEditing === true ? new Date(formik.values.fimColheita).toLocaleDateString() : ""}
                                            readonly={true}
                                            className={classNames({ 'p-invalid': isFormFieldValid('fimColheita') })}
                                            yearRange={`2010:${new Date().getFullYear() + 5}`}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }

                                {formik.errors.fimColheita && formik.touched.fimColheita &&
                                    <ErrorValidationMessage message={formik.errors.fimColheita} />
                                }
                            </div>

                            <div className="p-d-flex p-jc-end p-mr-1">

                                <Button
                                    icon="pi pi-plus"
                                    type="button"
                                    iconPos="right"
                                    onClick={formik.handleSubmit}
                                    loading={isSubmiting}
                                />
                            </div>

                            <div className="p-formgrid p-grid p-fluid p-mx-0">

                            </div>


                        </div>

                    </form>
                </div>
            </div>


        </Fieldset>

    );
}
